import { render } from "./Dashboard.vue?vue&type=template&id=75005564&scoped=true"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"

import "./Dashboard.vue?vue&type=style&index=0&id=75005564&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-75005564"

export default script